import { Component, OnInit } from '@angular/core';
import { AgRendererComponent } from 'ag-grid-angular';
import { IAfterGuiAttachedParams, ICellRendererParams } from 'ag-grid-community';
import * as _ from 'lodash-es';
import { TimesheetBreakdownRuleService } from '../services/timesheet-breakdown-rule.service';
import { PayCategory } from '../shared/models/pay-category';
import { IRosterCode } from '../shared/models/roster-code';
import { TimesheetBreakdownRule } from '../shared/models/timesheet-breakdown-rule';


@Component({
  selector: 'pps-roster-code-dropdown',
  template: `
    <i *ngIf="updating" class="fa fa-circle-o-notch fa-spin fa-fw"></i>
    <select *ngIf="!updating" [compareWith]="compare" [(ngModel)]="selectedRosterCode" (change)="onChange($event, selectedRosterCode)">
      <option *ngFor="let rc of rosterCodes" [ngValue]="rc">{{rc.code}} - {{rc.description}}</option>
    </select>
  `,
  styles: [
  ],
})
export class RosterCodeDropdownComponent implements AgRendererComponent {
  private params: any;
  updating: boolean = false;
  rosterCodes: IRosterCode[] = [];
  selectedRosterCode: IRosterCode;

  constructor() { }

  refresh(params: any): boolean {
    return false;
  }

  agInit(params: ICellRendererParams): void {
    this.params = params;

    let parent = params.context.componentParent;
    
    this.rosterCodes = parent.rosterCodes;

    this.selectedRosterCode = params.data.rosterCode;
  }

  afterGuiAttached?(params?: IAfterGuiAttachedParams): void {
    throw new Error("Method not implemented.");
  }

  onChange(evt, rosterCode){
    let parent = this.params.context.componentParent;
    let ruleId = this.params.data.id;
    let foundIndex = parent.rules.findIndex(x => x.id === ruleId);
    if (foundIndex === -1){
      console.log("Something wrong");
      return;
    }

    let selectedRule = parent.rules[foundIndex];
    let oldRosterCodeId = this.params.data.rosterCode?.id;
    if (rosterCode.id !== oldRosterCodeId){
      let rule = _.cloneDeep(selectedRule);
      rule.rosterCode = _.cloneDeep(rosterCode);
      this.updating = true;
      parent.updateRule(rule, "roster-code", null, null, null, () => this.updating = false);
    }
  }

  compare(a, b){
    return a&&b ? a.id === b.id : false;
  }
}